import type { AccountId } from '../../model/index.tsx';
import { getBoard } from '../../rest/board/get/index.tsx';
import { transformUserAccountFromBoard } from './transformers.tsx';

export const getUserBoardOwnerAccountId = async (boardId: string): Promise<AccountId> => {
	const response = await getBoard(boardId);

	return transformUserAccountFromBoard(response);
};
